
const { document } = require('window');

const $ = require('jquery');
require('./bootstrap');

const cuid = require('cuid');

const getTargetByAttr = require('./get-target-by-attr.js');


/*
 * Extended bootstrap collapse
 *
 * Added features:
 *  * `data-target` attribute supports pseudo-selector '$next', '$prev'
 *	meaning next or prev element in the DOM (like `$(element).next()`)
 *  * event default is always prevented for anchors
 *  * when collapsing in and out element classes 'collapsing-in' and 'collapsing-out' are set
 *  * 'parent' options does not depend on '.panel' (workaround https://github.com/twbs/bootstrap/issues/10966)
 *  * inputs may toggle collapse with their focus
 */

/* eslint-disable max-len */

const Collapse = $.fn.collapse.Constructor;

const ExtendedCollapse = function () {
	Collapse.apply(this, arguments);
	this.constructor = ExtendedCollapse;
	return this;
};

ExtendedCollapse.prototype = $.extend({}, Collapse.prototype, {
	show: function () {
		if (this.transitioning || this.$element.hasClass('in'))			{
			return;
		}

		let activesData;
		const actives = this.$parent
			&& this.$parent
			.find('.collapse.in, .collapse.collapsing')
			.not($('.collapse .collapse.in, .collapse .collapse.collapsing', this.$parent));

		if (actives && actives.length) {
			activesData = actives.data('bs.collapse');
			if (activesData && activesData.transitioning)				{
				return;
			}
		}

		const startEvent = $.Event('show.bs.collapse');
		this.$element.trigger(startEvent);
		if (startEvent.isDefaultPrevented())			{
			return;
		}

		if (actives && actives.length) {
			ExtendedPlugin.call(actives, 'hide');
			activesData || actives.data('bs.collapse', null );
		}

		const dimension = this.dimension();

		this.$element
			.removeClass('collapse')
			.addClass('collapsing')[dimension](0)
			.attr('aria-expanded', true);

		this.$trigger
			.removeClass('collapsed')
			.attr('aria-expanded', true);

		this.transitioning = 1;

		const complete = function () {
			this.$element
				.removeClass('collapsing')
				.addClass('collapse in')[dimension]('');
			this.transitioning = 0;
			this.$element
				.trigger('shown.bs.collapse');
		};

		if (!$.support.transition) {
			return complete.call(this);
		}

		const scrollSize = $.camelCase(['scroll', dimension].join('-'));

		this.$element
			.one('bsTransitionEnd', $.proxy(complete, this))
			.emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize]);
	},
	getParent: function () {
		return $(this.options.parent)
			.find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
			.each($.proxy(function (i, element) {
				const $element = $(element);
				this.addAriaAndCollapsedClass(getTargetByAttr($element, 'data-target'), $element);
			}, this))
				.end();
	},
});

function ExtendedPlugin (option) {
	return this.each(function () {
		const $this = $(this);
		let data	= $this.data('bs.collapse');
		const options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option);

		if (!data && options.toggle && /show|hide/.test(option)) {
			options.toggle = false;
		}
		if (!data) {
			$this.data('bs.collapse', (data = new ExtendedCollapse(this, options)));
		}
		if (typeof option == 'string') {
			data[option]();
		}
	});
}

$.fn.collapse = ExtendedPlugin;
$.fn.collapse.Constructor = ExtendedCollapse;

module.exports = $.fn.collapse;


function dataApiEventHandler (e) {
	const $this = $(e.currentTarget);

	if (!$this.attr('data-target')) {
		e.preventDefault();
	}

	const $target = getTargetByAttr($this, 'data-target');
	// Bootstrap collapse relies on matching `id`s with `data-target`s, so we generate them if necessary
	let id;
	if ($target.attr('id')) {
		id = $target.attr('id');
	} else {
		id = cuid();
		$target.attr('id', id);
	}
	$this.attr('data-target', '#' + id);

	const data = $target.data('bs.collapse');
	const defaultCommand = {
		focusin: 'show',
		focusout: 'hide',
	}[e.type] || 'toggle';
	const option = data ? defaultCommand : $this.data();

	ExtendedPlugin.call($target, option);
}

$(document)
	.off('click.bs.collapse.data-api')
	.on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
		const $this = $(this);

		if ($this.is('input')) {
			return;
		}

		dataApiEventHandler(e);
	})
	.on('click.bs.collapse.data-api', 'a[data-toggle="collapse"]', function (e) {
		e.preventDefault();
	})
	.on('focusin.bs.collapse.data-api focusout.bs.collapse.data-api',
		'input[data-toggle="collapse"]',
		function (e) {
			dataApiEventHandler(e);
		}
	);

$(document).on('show.bs.collapse shown.bs.collapse', function (e) {
	$(e.target).toggleClass('collapsing-in', e.type === 'show');
});
$(document).on('hide.bs.collapse hidden.bs.collapse', function (e) {
	$(e.target).toggleClass('collapsing-out', e.type === 'hide');
});

